import {crudStorage} from "./crudStorage";

export function downloadFile(dashState, path, fileName, toast) {
  crudStorage(
    dashState,
    "download",
    fileName,
    dashState.organization?.s3BucketName || "brightlighthealth",
    path
  )
    .then((res) => {
      const link = document.createElement("a");
      link.href = res.data;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up the blob URL after download
      if (res.data.startsWith('blob:')) {
        setTimeout(() => URL.revokeObjectURL(res.data), 100);
      }
      
      toast({
        title: "Download started",
        description: `Downloading ${fileName}`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    })
    .catch((err) => {
      console.error("Download error:", err);
      toast({
        title: "Download failed",
        description: "Could not download the file",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    });
}